










































import Block from '../components/Block.vue'
import OutputTable from '../components/OutputTable.vue'
import Button from '../components/parts/Button.vue'
import Steppers from '../components/parts/Steppers.vue'
import { defineComponent, ref, onMounted, inject } from '@vue/composition-api'
import { key } from '../store'

export default defineComponent({
  name: 'ProgrammerBlock',
  components: {
    Block,
    OutputTable,
    Button,
    Steppers,
  },
  setup() {
    const childBlock = ref<InstanceType<typeof Block>>()
    const outputsTable = ref<InstanceType<typeof OutputTable>>()
    const root = ref()
    const store = inject(key)
    if (!store) {
      throw new Error('')
    }
    const music = new Audio()
    music.volume = 0.2
    music.src = './sound/other_sound.mp3'
    const click = () => {
      music.play()
      if (childBlock.value) {
        const outputs = childBlock.value.output()
        store.setOutputs(outputs)
        store.setBlocks(childBlock.value.blockToCode())
        outputsTable.value?.setOutputs(outputs)
      }
    }
    onMounted(() => {
      resizeTable()
      if (!childBlock.value) {
        return
      }
      childBlock.value.initializeBlock(store.state.blocks)
      music.load()
    })
    const resizeTable = () => {
      if (root.value) {
        // テーブルの高さを親要素の80%にしている
        outputsTable.value?.updateTableHeight(root.value.clientHeight * 0.8 + 'px')
      }
    }
    return {
      click,
      childBlock,
      outputsTable,
      root,
      resizeTable,
      dialog: false,
    }
  },
})
